import { useState, useEffect } from 'react';

/**
 * Returns `value`, but only updates after `delayMs` of no further changes -
 * used to avoid firing a network request on every keystroke (e.g. search
 * suggestions). No debounce utility previously existed in this codebase.
 *
 * @template T
 * @param {T} value
 * @param {number} delayMs
 * @returns {T}
 */
export function useDebounce(value, delayMs) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
